

















import { Result } from '@empathy/search-types';
import { Components } from '@empathybroker/ebx-gluon';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  components: {
    A2CButton: Components.Pure.ResultAddToCartButton
  }
})
export default class GoccoAdd2CartButton extends Vue {
  @Prop({ required: true })
  private item: Result;
  private size: string;
  private selectedSize: string = this.item['sizes'][0];

  selectSize(size: string) {
    this.selectedSize = size;
  }

  addToCart() {}

}
